import axiosInstance from "../../../components/authentication/helper/axiosApi";
import { ActionTypes } from "../../constants/action-types";


// Connections
export const fetchConnectionsAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/myConnections/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_MY_CONNECTIONS,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

// Profile Connections
export const fetchProfileConnectionsAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/myProfileConnections/${profileId}/`);
// console.log(response);
            dispatch({
                type: ActionTypes.SET_PROFILE_CONNECTIONS,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

export const sendProfileConnectionRequestAction = (data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/sendProfileConnectionRequest/`, data);

        } catch (error) {

        }
    };
};


export const withDrawProfileConnectionAction = (id, data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/withDrawProfileConnectionRequest/`, data);
            dispatch({
                type: ActionTypes.REMOVE_PENDING_PROFILE_CONNECTION,
                payload: id,
            });
        } catch (error) {

        }
    };
};


// Connection requests
// Add me to your network
export const fetchAcceptConnectionRequestsAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/connectionRequests/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_ACCEPT_CONNECTION_REQUESTS,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

export const acceptConnectionRequestAction = (requestId, connection) => {
    return async (dispatch) => {
        try {
            await axiosInstance.get(`api/network/acceptConnectionRequest/${requestId}/`);

            dispatch({
                type: ActionTypes.REMOVE_ACCEPT_REQUEST,
                payload: connection,
            });

            dispatch({
                type: ActionTypes.ADD_MY_CONNECTION,
                payload: connection,
            });

        } catch (error) {

        }
    };
};

export const ignoreConnectionRequestAction = (request, connection) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/declineConnectionRequest/`, request);


            dispatch({
                type: ActionTypes.REMOVE_ACCEPT_REQUEST,
                payload: connection,
            });

            dispatch({
                type: ActionTypes.ADD_SUGGESTION_CONTACT,
                payload: connection,
            });

        } catch (error) {

        }
    };
};
// Pending connection requests
export const fetchPendingConnectionRequestsAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/pendingConnectionRequest/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_PENDING_CONNECTION_REQUESTS,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

export const withDrawPedingConnectionAction = (receiver, data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/withDrawConnectionRequest/`, data);
            dispatch({
                type: ActionTypes.ADD_SUGGESTION_CONTACT,
                payload: receiver,
            });
            dispatch({
                type: ActionTypes.REMOVE_PENDING_CONNECTION,
                payload: receiver[0].id,
            });
        } catch (error) {

        }
    };
};



// Pending profile requests
export const fetchPendingProfileConnectionsAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/profileConnectionRequests/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_ACCEPT_PROFILE_CONNECTION,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

export const fetchPendingProfileRequestsAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/profilePendingRequest/`);
            dispatch({
                type: ActionTypes.SET_PENDING_PROFILE_REQUESTS,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

export const acceptProfileConnectionAction = (id, connection) => {
    return async (dispatch) => {
        try {
            await axiosInstance.get(`/api/network/acceptProfileConnectionRequest/${id}/`);

            dispatch({
                type: ActionTypes.REMOVE_ACCEPT_PROFILE_CONNECTION,
                payload: connection,
            });

            dispatch({
                type: ActionTypes.ADD_MY_PROFILE_CONNECTION,
                payload: connection,
            });

        } catch (error) {

        }
    };
};

export const ignoreProfileConnectionAction = (data, connection) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/declineProfileConnectionRequest/`, data);


            dispatch({
                type: ActionTypes.REMOVE_ACCEPT_PROFILE_CONNECTION,
                payload: connection,
            });


        } catch (error) {

        }
    };
};
// Grow your contacts
// IN YOUR PROFESSION - YOUR PEERS
export const fetchInYourProfessionalPeerAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/professionalPeerConnections/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_YOUR_PROFESSION_PEERS,
                payload: response.data,
            });

        } catch (error) {

        }
    };
};


export const sendProfessionConnectionAction = (receiver, data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/sendConnectionRequest/`, data);
            dispatch({
                type: ActionTypes.ADD_PENDING_REQUEST,
                payload: receiver,
            });
            dispatch({
                type: ActionTypes.REMOVE_PROFESSION_CONNECTION,
                payload: receiver,
            });
        } catch (error) {

        }
    };
};



// SUGGESTED CONTACTS
export const fetchSuggestedContactsAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/suggestedConnections/${profileId}/`);
            dispatch({
                type: ActionTypes.SET_SUGGESTED_CONTACTS,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};


export const sendSuggestedConnectionAction = (receiver, data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/sendConnectionRequest/`, data);
            dispatch({
                type: ActionTypes.ADD_PENDING_REQUEST,
                payload: receiver,
            });
            dispatch({
                type: ActionTypes.REMOVE_SUGGESTION_CONNECTION,
                payload: receiver,
            });
        } catch (error) {

        }
    };
};


// References
export const fetchMyReferencesAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/userReferences/`);
            dispatch({
                type: ActionTypes.SET_MY_REFERENCES,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

// My Contacts by Location
export const fetchMyContactsLocationMapAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/connectionLocations/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_LOCATION_MAP,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

// My Contacts
export const fetchMyContactsImagesAction = (profileId) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`api/network/imageList/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_MY_CONTACTS,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};


// Send My Profile connection
export const sendProfileConnectionAction = (data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/sendProfilePdf/`, data);

        } catch (error) {

        }
    };
};

export const sendMyPofileAction = (id) => {
    return async (dispatch) => {
        try {

            await axiosInstance.get(`api/network/acceptProfileConnectionRequest/${id}/`);

        } catch (error) {

        }
    };
};

export const removeMyProfileAction = (data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`api/network/removeProfilePdfConnection/`, data);

        } catch (error) {

        }
    };
};

// References
export const fetchRequestedReferenceAction = (profileId) => {
  return async (dispatch) => {
    console.log('-------------->fetch ref');

    try {
      const response = await axiosInstance.get(`/api/network/requestedReference/${profileId}/`);
      const data = response.data;
      console.log('-------------->data');
      console.log(data);
      // Log only profile_pic from each item
      data.forEach((user, index) => {
        console.log(`User ${index + 1} profile_pic:`, user.profile_pic);
      });

      // Extract and log all referees_email addresses
      const emails = [];

      data.forEach(user => {
        user.references.forEach(ref => {
          if (ref.referees_email) {
            emails.push(ref.referees_email);
          }
        });
      });

      console.log('All referees_email:', emails);

      dispatch({
        type: ActionTypes.SET_REQUESTED_REFERENCE,
        payload: data,
      });
    } catch (error) {
      console.error('Failed to fetch requested references:', error);
    }
  };
};
//delete
export const sendReferenceRequestedAction = (data, referenceId, removeObj) => {
    return async (dispatch) => {
        try {
            await axiosInstance.put(`api/network/reference/${referenceId}/`, data);

            dispatch({
                type: ActionTypes.REMOVE_REQUESTED_REFERENCE,
                payload: removeObj,
            });

        } catch (error) {

        }
    };
};
///////////////////////////////////////////////////////////////////////
export const deleteReferenceRequestAction = (referenceId) => {
    return async (dispatch) => {
        try {
            await axiosInstance.delete(`api/network/reference/${referenceId}/`);
            
            dispatch({
                type: ActionTypes.REMOVE_REQUESTED_REFERENCE,
                payload: referenceId,
            });
            
        } catch (error) {
            console.error("Error deleting reference:", error);
            // Handle error as needed
        }
    };
};
//////////////////////////////////////////////////////////////////////

export const updateUserReferenceAction = (data, referenceId) => {
    return async (dispatch) => {
        try {
            await axiosInstance.put(`api/network/reference/${referenceId}/`, data);
            //  dispatch({
            //     type: ActionTypes.UPDATE_REQUEST_REFERENCE,
            //     payload: data,
            // });
        } catch (error) {

        }
    };
};